import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getActiveBlogHighlights } from '../api/blogHighlightApi';

// Fallback content shown if the API has no data yet / fails to load,
// so the section never renders empty.
const FALLBACK_POSTS = [
  {
    id: 1,
    title: "The inaugural edition kick-started Advantage Vidarbha.",
    bgImg: "img/blog/1.jpg",
    link: "/img/AV-2024.pdf",
    isPdf: true,
    date: { day: "1", month: "Edition", year: "2023" }
  },
  {
    id: 2,
    title: "The second edition strengthened the momentum",
    bgImg: "img/blog/2.jpg",
    link: "/img/AV-2025.pdf",
    isPdf: true,
    date: { day: "2", month: "Edition", year: "2025" }
  },
  {
    id: 3,
    title: "The 3rd edition is set to take place from 6th to 8th February 2026.",
    bgImg: "img/blog/3.png",
    link: "/img/AV-2025.pdf",
    isPdf: true,
    date: { day: "3", month: "Edition", year: "2026" }
  }
];

const BlogSection = () => {
  const [blogPosts, setBlogPosts] = useState(FALLBACK_POSTS);

  useEffect(() => {
    const fetchHighlights = async () => {
      try {
        const data = await getActiveBlogHighlights();
        if (Array.isArray(data) && data.length > 0) {
          setBlogPosts(data.map((item) => ({
            id: item._id,
            title: item.title,
            bgImg: item.image,
            link: item.link,
            isPdf: item.linkType === 'pdf',
            external: item.linkType === 'external',
            date: {
              day: item.badgeDay,
              month: item.badgeMonth,
              year: item.badgeYear
            }
          })));
        }
      } catch (error) {
        console.error('Error fetching blog highlights:', error);
      }
    };

    fetchHighlights();
  }, []);

  return (
    <div className="blog_section">
      <div className="overlay" data-bg-img="img/blog/map.png"></div>
      
      {/* Main Title */}
      <div className="fn_cs_main_title">
        <div className="container">
          <div className="title_holder">
            <h3>Highlights of Advantage Vidarbha</h3>
          </div>
        </div>
      </div>
      {/* /Main Title */}
      
      {/* Triple Blog Modern Shortcode */}
      <div className="fn_cs_triple_blog_modern fn_alpha">
        <div className="container">
          <div className="inner">
            <ul>
              {blogPosts.map(post => (
                <li key={post.id}>
                  <div className="item">
                    <div
                      className="img_holder"
                      data-bg-img={post.bgImg}
                      style={{ backgroundImage: `url("${post.bgImg}")` }}
                    >
                      <div className="time">
                        <span></span>
                        <h3>{post.date.day}</h3>
                        <h5>{post.date.month}</h5>
                        <h5>{post.date.year}</h5>
                      </div>
                      {post.isPdf ? (
                        <a href={post.link} target="_blank" rel="noopener noreferrer"></a>
                      ) : post.external ? (
                        <a href={post.link} target="_blank" rel="noopener noreferrer"></a>
                      ) : (
                        <Link to={post.link}></Link>
                      )}
                      <img src="img/thumb/370-250.jpg" alt="" />
                    </div>
                    <div className="title_holder">
                      {/* <p className="t_header">
                        By <a href="#">Frenify</a> — In <a href="#">Australia</a>
                      </p> */}
                      <h3>
                        {post.isPdf ? (
                          <a href={post.link} target="_blank" rel="noopener noreferrer">{post.title}</a>
                        ) : post.external ? (
                          <a href={post.link} target="_blank" rel="noopener noreferrer">{post.title}</a>
                        ) : (
                          <Link to={post.link}>{post.title}</Link>
                        )}
                      </h3>
                      <p className="t_footer">
                        {post.isPdf ? (
                          <a href={post.link} target="_blank" rel="noopener noreferrer">View Report</a>
                        ) : post.external ? (
                          <a href={post.link} target="_blank" rel="noopener noreferrer">View Report</a>
                        ) : (
                          <Link to={post.link}>View Report</Link>
                        )}
                      </p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      {/* /Triple Blog Modern Shortcode */}
    </div>
  );
};

export default BlogSection;